var publicPath = __webpack_public_path__;
                    var symbolUrl = 'sprite.svg#icon-juridique-bg-violet';
                    var viewUrl = 'sprite.svg#view-icon-juridique-bg-violet';

                    

                    module.exports = {
                        symbol: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 81 62',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };